import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { BsCheckCircle, BsFillCheckCircleFill, BsCircle } from "react-icons/bs";
import { Icon } from "./Icon";

export function EvaluacionDetalle({ paralelo, estudiantes }) {

  return (
    paralelo.verlista && estudiantes.length > 0
    && <ListGroup numbered="true">
      {estudiantes.map((e, i) =>
        <ListGroupItem key={i}>
              {i + 1}.- {e.estado == "P" || e.estado == "N" ? <Icon icon={<BsFillCheckCircleFill />} style={{ color: "green" }} /> : e.estado == "R" ? <Icon icon={<BsFillCheckCircleFill />} style={{ color: "yellow" }} /> : <Icon icon={<BsCircle />} />}{' '}{e.estudiante}
        </ListGroupItem>) }
    </ListGroup>
  );
}
